/**
 * Creates a debounced function that accumulates arguments from multiple calls.
 *
 * @param {Function} func The function to debounce.
 * @param {number} wait The number of milliseconds to delay.
 * @param {Function} accumulator A function that takes the current accumulated value and the new arguments, and returns the new accumulated value.
 * @param {any} initialValue The initial value for the accumulator.
 * @returns {Function} The new debounced function.
 */
export default function debounceAccumulate(func, wait, accumulator, initialValue) {
    let timeout;
    let argsAccumulator = initialValue;

    return function (...args) {
        const context = this;

        // Update the accumulated arguments
        argsAccumulator = accumulator(argsAccumulator, ...args);

        const later = function () {
            timeout = null;
            const currentArgs = argsAccumulator;
            // Reset accumulator for the next run
            argsAccumulator = initialValue;
            func.apply(context, [currentArgs]);
        };

        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
